import { render, staticRenderFns } from "./PostponeReminderModal.vue?vue&type=template&id=e4bb674a&"
import script from "./PostponeReminderModal.vue?vue&type=script&lang=js&"
export * from "./PostponeReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports